import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import { WAButton } from './Button.js';
import CustomAlert from './CustomAlert';


class AddressConfirmPryForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            accept_address: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const address_options_prj = [{id:0 , name:'Si'}, {id:1 , name:'No'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_confirm_address_pry" description="Company type"/>
                    <div className="show-desktop">
                        <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.saveConfirmPryAddress)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="address_confirm_pry" defaultValue="¿El domicilio del Proyecto es igual al domicilio especial?" label="¿El domicilio del Proyecto es igual al domicilio especial?" attributeName='address_confirm_pry' attributeOptions={address_options_prj}/>
                                    </div>
                                </div>
                            </div>                         
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

AddressConfirmPryForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

AddressConfirmPryForm = TopScrolleable(AddressConfirmPryForm);
let validate = generateValidator([{name: 'address_confirm_pry', required: true}]);

AddressConfirmPryForm = reduxForm({
    form: 'AdressConfirmPryForm', // a unique name for this form
    validate
})(AddressConfirmPryForm);

AddressConfirmPryForm = withAuthControl(AddressConfirmPryForm);

export default AddressConfirmPryForm;



/** WEBPACK FOOTER **
 ** ./src/components/AddressConfirmPryForm.js
 **/